const types = {
    SET_LIST: '[PAYMENT] SET LIST',
}

export {
    types
}